import travelData from './travel_data.json';
import cryotherapyData from './cryotherapy_data.json';

const database = {};
database.travel = travelData;
database.cryotherapy = cryotherapyData;
export default database;